<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import {
		storeElementID,
		storeData,
		storeShowRooms,
		storeSelectedIcon,
	} from '../../library/scripts/Store.svelte'
	import { get_element_tags, get_initial_values, string_to_fontsize, get_blocks } from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	let iconAlignL = globals.colorDark
	let iconAlignC = globals.colorDark
	let iconAlignR = globals.colorDark
	let iconTxtContAlignL = globals.colorDark
	let iconTxtContAlignC = globals.colorDark
	let iconTxtContAlignR = globals.colorDark
	let iconValignT = globals.colorDark
	let iconValignC = globals.colorDark
	let iconValignB = globals.colorDark
	let iconWeight = globals.colorDark
	let iconStyle = globals.colorDark
	let iconDeco = globals.colorDark
	let iconStroke = globals.colorDark
	let mainTool = globals.mainTool
	let mainToolHover = globals.mainToolHover
	let subTool = globals.subTool
	let subToolHover = globals.subToolHover
	const iconHover = globals.colorError
	const fontSize = globals.fontSize
	const fontFamily = globals.fontFamily
	const fontSizeSmall = globals.fontSizeSmall

	let generalTool1
	let generalTool2
	let generalTool3
	let showTool0
	let showTool1
	let showTool2
	let showTool3
	let showTool4
	let showTool5
	let showTool6
	let showTool7
	let showTool8
	let showTool9
	let showTool10
	let showTool11
	let showTool12
	let showTool13
	let showTool14

	let elementID
	let config
	let blocks
	let blockID, columnID, elementTag

	//show border tools
	let iconSelected = false

	//icon selected
	let selectedIcon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor

	//css selections
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let blockMarginTop,
		blockMarginBottom,
		blockPadding,
		blockBackgroundColor,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		blockTitle,
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		roomsContainerBG,
		roomsContainerMT,
		roomsContainerMB,
		roomsConatainerP,
		roomsSC,
		roomsSX,
		roomsSY,
		roomsSB,
		roomsBW,
		roomsBRT,
		roomsBRB,
		roomsBG,
		roomsMT,
		roomsMB,
		roomsBS,
		roomsBC,
		roomsTFC,
		roomsTFS,
		roomsTFSTY,
		roomsTFW,
		roomsTP,
		roomsIMGX,
		roomsIMGY,
		roomsIMGB,
		roomsIMGC,
		roomsDescShortFC,
		roomsDescShortFS,
		roomsDescShortFSTY,
		roomsDescShortFW,
		roomsDescShortP,
		roomsPriceFC,
		roomsPriceFS,
		roomsPriceFSTY,
		roomsPriceFW,
		roomsLinkFC,
		roomsLinkFS,
		roomsLinkFSTY,
		roomsLinkFW,
		roomsLinkHover,
		blockBgOpac,
		blockTitleBgOpac,
		backgroundImage,
		backgroundSize,
		backgroundRepeat,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		blockBorderOpac,
		blockTitleTXTShadowColor,
		blockTitleTXTShadowOffsetX,
		blockTitleTXTShadowOffsetY,
		blockTitleTXTShadowBlur,
		roomsP,
		roomsTFF,
		roomsIMGW,
		roomsDescShortFF,
		roomsPriceFF,
		roomsLinkFF

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'
	let idColor1 = '101'
	let idColor2 = '102'
	let idColor3 = '103'
	let idColor4 = '104'
	let idColor5 = '105'
	let idColor6 = '106'
	let idColor7 = '107'
	let idColor8 = '108'
	let idColor9 = '109'
	let idColor10 = '110'
	let idColor11 = '111'
	let idColor12 = '112'
	let idColor13 = '113'
	let idColor14 = '114'
	let idColor15 = '115'
	let idMarginTop = '3'
	let idMarginBottom = '4'
	let idPadding = '5'
	let idBorderWidth = '6'
	let idBTradius = '7'
	let idBBradius = '8'
	let idShadowY = '9'
	let idShadowBlur = '10'
	let idTTXTShadowX = '11'
	let idTTXTShadowY = '12'
	let idTTXTShadowBlur = '13'
	let idRoomsMT = '14'
	let idRoomsMB = '15'
	let idRoomsP = '16'
	let idRoomsBRT = '17'
	let idRoomsBRB = '18'
	let idRoomsBW = '20'
	let idTitleShadowY = '21'
	let idTitleShadowBlur = '22'
	let idRoomsSX = '23'
	let idRoomsSY = '24'
	let idRoomsSB = '25'
	let idRoomsIMGW = '26'
	let idTitleHeight = '28'
	let idTitleMT = '29'
	let idTitleMB = '30'
	let idTitleP = '31'
	let idRoomsIMGSX = '32'
	let idRoomsIMGSY = '33'
	let idRoomsIMGSB = '34'

	//change layout order
	let shaderChangeOrder = false

	//the values to send to sizeSelectors
	let selectedBorderWidth

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	let selectedStoreIcon
	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = borderLeftWidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = borderTopWidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = borderRightWidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = borderBottomWidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = borderLeftWidth

	const set_icon_color = (c) => {
		if (c === 'left') icon1Color = iconHover
		if (c === 'top') icon2Color = iconHover
		if (c === 'right') icon3Color = iconHover
		if (c === 'bottom') icon4Color = iconHover
		if (c === 'all') {
			icon1Color = iconHover
			icon2Color = iconHover
			icon3Color = iconHover
			icon4Color = iconHover
			icon5Color = iconHover
		}
		if (c === 'none') {
			icon1Color = iconColor
			icon2Color = iconColor
			icon3Color = iconColor
			icon4Color = iconColor
			icon5Color = iconColor
		}
	}

	//set the initial css values from config.json
	$: if (elementID === 'rooms') {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		columnID = tags[1]
		elementTag = tags[2]
		const values = get_initial_values(elementID, blocks, tags)
		blockMarginTop = values[0]
		blockMarginBottom = values[1]
		blockPadding = values[2]
		blockBackgroundColor = values[3]
		blockBoxShadowX = values[4]
		blockBoxShadowY = values[5]
		blockBoxShadowBlur = values[6]
		blockBoxShadowColor = values[7]
		blockTitle = values[8]
		blockTitleWidth = values[9]
		blockTitleHeight = values[10]
		blockTitleAlignHorizontal = values[11]
		blockTitleAlignVertical = values[12]
		blockTitleFontFamily = values[13]
		blockTitleFontColor = values[14]
		blockTitleFontSize = values[15]
		blockTitleFontWeight = values[16]
		blockTitleFontStyle = values[17]
		blockTitleFontDeco = values[18]
		blockTitleBackgroundColor = values[19]
		blockTitleMarginTop = values[20]
		blockTitleMarginBottom = values[21]
		blockTitlePadding = values[22]
		blockTitleShadowColor = values[23]
		blockTitleShadowOffsetX = values[24]
		blockTitleShadowOffsetY = values[25]
		blockTitleShadowBlur = values[26]
		roomsContainerBG = values[27]
		roomsContainerMT = values[28]
		roomsContainerMB = values[29]
		roomsConatainerP = values[30]
		roomsSC = values[31]
		roomsSX = values[32]
		roomsSY = values[33]
		roomsSB = values[34]
		roomsBW = values[35]
		roomsBRT = values[36]
		roomsBG = values[37]
		roomsMT = values[38]
		roomsMB = values[39]
		roomsBS = values[40]
		roomsBC = values[41]
		roomsTFC = values[42]
		roomsTFS = values[43]
		roomsTFSTY = values[44]
		roomsTFW = values[45]
		roomsTP = values[46]
		roomsIMGX = values[47]
		roomsIMGY = values[48]
		roomsIMGB = values[49]
		roomsIMGC = values[50]
		roomsDescShortFC = values[51]
		roomsDescShortFS = values[52]
		roomsDescShortFSTY = values[53]
		roomsDescShortFW = values[54]
		roomsDescShortP = values[55]
		roomsPriceFC = values[56]
		roomsPriceFS = values[57]
		roomsPriceFSTY = values[58]
		roomsPriceFW = values[59]
		roomsLinkFC = values[60]
		roomsLinkFS = values[61]
		roomsLinkFSTY = values[62]
		roomsLinkFW = values[63]
		roomsLinkHover = values[64]
		blockBgOpac = values[65]
		blockTitleBgOpac = values[66]
		backgroundImage = values[67]
		backgroundSize = values[68]
		backgroundRepeat = values[69]
		borderTopRadius = values[70]
		borderBottomRadius = values[71]
		borderLeftWidth = values[72]
		borderLeftStyle = values[73]
		borderLeftColor = values[74]
		borderTopWidth = values[75]
		borderTopStyle = values[76]
		borderTopColor = values[77]
		borderRightWidth = values[78]
		borderRightStyle = values[79]
		borderRightColor = values[80]
		borderBottomWidth = values[81]
		borderBottomStyle = values[82]
		borderBottomColor = values[83]
		blockBorderOpac = values[84]
		blockTitleTXTShadowColor = values[85]
		blockTitleTXTShadowOffsetX = values[86]
		blockTitleTXTShadowOffsetY = values[87]
		blockTitleTXTShadowBlur = values[88]
		roomsP = values[89]
		roomsBRB = values[90]
		roomsTFF = values[91]
		roomsIMGW = values[92]
		roomsDescShortFF = values[93]
		roomsPriceFF = values[94]
		roomsLinkFF = values[95]
		set_fontstyle_initial_value(blockTitleFontWeight, blockTitleFontStyle, blockTitleFontDeco)
		set_icon_title_align_initial_value(blockTitleAlignHorizontal)
		set_icon_title_valign_initial_value(blockTitleAlignVertical)

		if (borderLeftWidth > 0) {
			icon1 = true
			set_icon_color('left')
		}
		if (borderTopWidth > 0) {
			icon2 = true
			set_icon_color('top')
		}

		if (borderRightWidth > 0) {
			icon3 = true
			set_icon_color('right')
		}

		if (borderBottomWidth > 0) {
			icon4 = true
			set_icon_color('bottom')
		}

		if (borderLeftWidth > 0 && borderTopWidth > 0 && borderRightWidth > 0 && borderBottomWidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all')
		}
	}

	const set_icon_title_align_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconTxtContAlignL = iconHover
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconColor
				return
			}
			if (v === 'center') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconHover
				iconTxtContAlignR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconHover
				return
			}
		}
	}

	const set_fontstyle_initial_value = (w, s, d) => {
		if (w === 'bold') iconWeight = iconHover
		if (w === 'normal') iconWeight = iconColor
		if (s === 'italic') iconStyle = iconHover
		if (s === 'normal') iconStyle = iconColor
		if (d === 'none') {
			iconDeco = iconColor
			iconStroke = iconColor
		}
		if (d === 'underline') {
			iconDeco = iconHover
			iconStroke = iconColor
		}
		if (d === 'line-through') {
			iconDeco = iconColor
			iconStroke = iconHover
		}
	}

	const set_icon_title_valign_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconValignT = iconHover
				iconValignC = iconColor
				iconValignB = iconColor
				return
			}
			if (v === 'center') {
				iconValignT = iconColor
				iconValignC = iconHover
				iconValignB = iconColor
				return
			}

			if (v === 'flex-end') {
				iconValignT = iconColor
				iconValignC = iconColor
				iconValignB = iconHover
				return
			}
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'blockBG') block.blockBackgroundColor = cssTag
				if (cmd === 'blockMT') block.blockMarginTop = cssTag
				if (cmd === 'blockMB') block.blockMarginBottom = cssTag
				if (cmd === 'blockP') block.blockPadding = cssTag
				// block borders
				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderLeftWidth = 0
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderTopWidth = 0
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderRightWidth = 0
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderBottomWidth = 0
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.borderLeftWidth = 0
						block.borderTopWidth = 0
						block.borderRightWidth = 0
						block.borderBottomWidth = 0
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor
						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftWidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopWidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightWidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomWidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftWidth = cssTag
						block.borderTopWidth = cssTag
						block.borderRightWidth = cssTag
						block.borderBottomWidth = cssTag
					}
				}

				if (cmd === 'bColor') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderTopColor = cssTag
						block.borderRightColor = cssTag
						block.borderBottomColor = cssTag
					}
				}

				if (cmd === 'bColor') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderTopColor = cssTag
						block.borderRightColor = cssTag
						block.borderBottomColor = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.borderTopRadius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.borderBottomRadius = cssTag
				}

				if (cmd === 'sY') block.blockBoxShadowY = cssTag
				if (cmd === 'sB') block.blockBoxShadowBlur = cssTag
				if (cmd === 'sC') block.blockBoxShadowColor = cssTag
				if (cmd === 'titleHeight') block.blockTitleHeight = cssTag
				if (cmd === 'blockTitleMT') block.blockTitleMarginTop = cssTag
				if (cmd === 'blockTitleMB') block.blockTitleMarginBottom = cssTag
				if (cmd === 'blockTitleP') block.blockTitlePadding = cssTag
				if (cmd === 'blockTitleBG') block.blockTitleBackgroundColor = cssTag
				if (cmd === 'tsY') block.blockTitleShadowOffsetY = cssTag
				if (cmd === 'tsB') block.blockTitleShadowBlur = cssTag
				if (cmd === 'tsC') block.blockTitleShadowColor = cssTag
				if (cmd == 'tfC') block.blockTitleFontColor = cssTag
				if (cmd === 'tFF') block.blockTitleFontFamily = cssTag
				if (cmd === 'tFS') block.blockTitleFontSize = cssTag
				if (cmd === 'tFW') block.blockTitleFontWeight = cssTag
				if (cmd === 'tFSTY') block.blockTitleFontStyle = cssTag
				if (cmd === 'tFD') block.blockTitleFontDeco = cssTag
				if (cmd === 'tTXTsX') block.blockTitleTXTShadowOffsetX = cssTag
				if (cmd === 'tTXTsY') block.blockTitleTXTShadowOffsetY = cssTag
				if (cmd === 'tTXTsB') block.blockTitleTXTShadowBlur = cssTag
				if (cmd === 'tTXTsC') block.blockTitleTXTShadowColor = cssTag
				if (cmd === 'tTXTalign') block.blockTitleAlignHorizontal = cssTag
				if (cmd === 'tTXTvalign') block.blockTitleAlignVertical = cssTag
				if (cmd === 'rBGC') block.roomsBG = cssTag
				if (cmd === 'rMT') block.roomsMT = cssTag
				if (cmd === 'rMB') block.roomsMB = cssTag
				if (cmd === 'rP') block.roomsP = cssTag
				if (cmd === 'rBRT') block.roomsBRT = cssTag
				if (cmd === 'rBRB') block.roomsBRB = cssTag
				if (cmd === 'rBC') block.roomsBC = cssTag
				if (cmd === 'rBW') block.roomsBW = cssTag
				if (cmd === 'rSC') block.roomsSC = cssTag
				if (cmd === 'rSX') block.roomsSX = cssTag
				if (cmd === 'rSY') block.roomsSY = cssTag
				if (cmd === 'rSB') block.roomsSB = cssTag
				if (cmd === 'rTFC') block.roomsTFC = cssTag
				if (cmd === 'rTFF') block.roomsTFF = cssTag
				if (cmd === 'rTFS') block.roomsTFS = cssTag
				if (cmd === 'rIMGW') block.roomsIMGW = cssTag
				if (cmd === 'rIMGC') block.roomsIMGC = cssTag
				if (cmd === 'rIMGX') block.roomsIMGX = cssTag
				if (cmd === 'rIMGY') block.roomsIMGY = cssTag
				if (cmd === 'rIMGB') block.roomsIMGB = cssTag
				if (cmd === 'rTXTFC') block.roomsDescShortFC = cssTag
				if (cmd === 'rTXTFF') block.roomsDescShortFF = cssTag
				if (cmd === 'rTXTFS') block.roomsDescShortFS = cssTag
				if (cmd === 'rPFC') block.roomsPriceFC = cssTag
				if (cmd === 'rPFF') block.roomsPriceFF = cssTag
				if (cmd === 'rPFS') block.roomsPriceFS = cssTag
				if (cmd === 'rLFC') block.roomsLinkFC = cssTag
				if (cmd === 'rLFF') block.roomsLinkFF = cssTag
				if (cmd === 'rLFS') block.roomsLinkFS = cssTag
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const add_line_break = (cmd, start, end) => {
		let lineBreak
		let newText
		if (cmd === 'linebreak') lineBreak = '\n'
		if (cmd === 'paragraph') lineBreak = '\n\n'
		if (cmd === 'indent') lineBreak = '  '
		let text = document.getElementById(elementID).innerText
		let slice = text.slice(start, end)
		let head = text.slice(0, start)
		let tail = text.slice(end, text.length)
		if (cmd !== 'indent' || cmd !== 'resindent') {
			slice = slice + lineBreak
			newText = head + slice + tail
		}
		if (cmd === 'indent') {
			slice = lineBreak + slice
			const newSlice = slice.replace(/\s+$/, '')
			newText = head + newSlice + tail
		}

		if (cmd === 'resindent') {
			let newSlice = text.substring(start, end)
			let trimSlice = newSlice.trim()
			newText = head + trimSlice + tail
		}

		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[columnID - 1].text = newText
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_text_height = (e) => {
		set_css_tag(e.detail.value, 'textHeight')
	}

	const set_text_width = (e) => {
		set_css_tag(e.detail.value, 'textWidth')
	}

	const set_title_height = (e) => {
		set_css_tag(e.detail.value, 'titleHeight')
	}

	const set_title_margin_top = (e) => {
		set_css_tag(e.detail.value, 'blockTitleMT')
	}

	const set_title_margin_bottom = (e) => {
		set_css_tag(e.detail.value, 'blockTitleMB')
	}

	const set_title_padding = (e) => {
		set_css_tag(e.detail.value, 'blockTitleP')
	}

	const set_title_bg_color = (e) => {
		set_css_tag(e.detail.color, 'blockTitleBG')
	}

	const set_font_color = (e) => {
		set_css_tag(e.detail.color, 'fontColor')
	}

	const set_bg_color = (e) => {
		const hsl = e.detail.color
		set_css_tag(hsl, 'blockBG')
	}

	const set_block_title_font_family = (e) => {
		const font = e.detail.font
		set_css_tag(font, 'tFF')
	}

	const set_block_title_font_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'tFS')
	}

	const set_block_title_font_weight = () => {
		let fW = document.getElementById('roomstitle').style.fontWeight
		if (fW === '' || fW === 'normal') {
			iconWeight = iconHover
			set_css_tag('bold', 'tFW')
		} else {
			iconWeight = iconColor
			set_css_tag('normal', 'tFW')
		}
	}

	const set_block_title_font_style = () => {
		let fW = document.getElementById('roomstitle').style.fontStyle
		if (fW === '' || fW === 'normal') {
			iconWeight = iconHover
			set_css_tag('italic', 'tFSTY')
		} else {
			iconWeight = iconColor
			set_css_tag('normal', 'tFSTY')
		}
	}

	const set_block_title_font_underline = () => {
		let fW = document.getElementById('roomstitle').style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'line-through') {
			iconDeco = iconHover
			set_css_tag('underline', 'tFD')
		} else {
			iconDeco = iconColor
			set_css_tag('none', 'tFD')
		}
	}

	const set_block_title_font_strikethrough = () => {
		let fW = document.getElementById('roomstitle').style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'underline') {
			iconStroke = iconHover
			iconStyle = iconColor
			set_css_tag('line-through', 'tFD')
		} else {
			iconStroke = iconColor
			set_css_tag('none', 'tFD')
		}
	}

	const set_txt_container_align_left = () => {
		set_css_tag('flex-start', 'tTXTalign')
	}

	const set_txt_container_align_center = () => {
		set_css_tag('center', 'tTXTalign')
	}

	const set_txt_container_align_right = () => {
		set_css_tag('flex-end', 'tTXTalign')
	}

	const set_txt_container_valign_top = () => {
		set_css_tag('flex-start', 'tTXTvalign')
	}

	const set_txt_container_valign_center = () => {
		set_css_tag('center', 'tTXTvalign')
	}

	const set_txt_container_valign_bottom = () => {
		set_css_tag('flex-end', 'tTXTvalign')
	}

	const set_text_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'TSX')
	}

	const set_text_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'TSY')
	}

	const set_text_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'TSB')
	}

	const set_column_title_radius = (e) => {
		set_css_tag(e.detail.value, 'CTBR')
	}

	const set_margin_top = (e) => {
		set_css_tag(e.detail.value, 'blockMT')
	}

	const set_margin_bottom = (e) => {
		set_css_tag(e.detail.value, 'blockMB')
	}

	const set_padding = (e) => {
		set_css_tag(e.detail.value, 'blockP')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_title_offset_y = (e) => {
		set_css_tag(e.detail.value, 'tsY')
	}

	const set_title_blur = (e) => {
		set_css_tag(e.detail.value, 'tsB')
	}

	const set_title_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'tsC')
	}

	const set_title_font_color = (e) => {
		set_css_tag(e.detail.color, 'tfC')
	}

	const set_title_TXT_offset_y = (e) => {
		set_css_tag(e.detail.value, 'tTXTsY')
	}

	const set_title_TXT_offset_x = (e) => {
		set_css_tag(e.detail.value, 'tTXTsX')
	}

	const set_title_TXT_blur = (e) => {
		set_css_tag(e.detail.value, 'tTXTsB')
	}

	const set_title_TXT_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'tTXTsC')
	}

	const set_rooms_bg = (e) => {
		set_css_tag(e.detail.color, 'rBGC')
	}

	const set_rooms_mt = (e) => {
		set_css_tag(e.detail.value, 'rMT')
	}

	const set_rooms_mb = (e) => {
		set_css_tag(e.detail.value, 'rMB')
	}

	const set_rooms_p = (e) => {
		set_css_tag(e.detail.value, 'rP')
	}

	const set_rooms_border_c = (e) => {
		set_css_tag(e.detail.color, 'rBC')
	}

	const set_rooms_border_w = (e) => {
		set_css_tag(e.detail.value, 'rBW')
	}

	const set_rooms_brt = (e) => {
		set_css_tag(e.detail.value, 'rBRT')
	}

	const set_rooms_brb = (e) => {
		set_css_tag(e.detail.value, 'rBRB')
	}

	const set_rooms_shadow_c = (e) => {
		set_css_tag(e.detail.color, 'rSC')
	}

	const set_rooms_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'rSX')
	}

	const set_rooms_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'rSY')
	}

	const set_rooms_shadow_b = (e) => {
		set_css_tag(e.detail.value, 'rSB')
	}

	const set_rooms_title_font_color = (e) => {
		set_css_tag(e.detail.color, 'rTFC')
	}

	const set_rooms_title_font_family = (e) => {
		set_css_tag(e.detail.font, 'rTFF')
	}

	const set_rooms_title_font_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'rTFS')
	}

	const set_rooms_imgw = (e) => {
		set_css_tag(e.detail.value, 'rIMGW')
	}

	const set_rooms_img_sc = (e) => {
		set_css_tag(e.detail.color, 'rIMGC')
	}

	const set_rooms_img_sx = (e) => {
		set_css_tag(e.detail.value, 'rIMGX')
	}

	const set_rooms_img_sy = (e) => {
		set_css_tag(e.detail.value, 'rIMGY')
	}

	const set_rooms_img_sb = (e) => {
		set_css_tag(e.detail.value, 'rIMGB')
	}

	const set_rooms_text_font_color = (e) => {
		set_css_tag(e.detail.color, 'rTXTFC')
	}

	const set_rooms_text_font_family = (e) => {
		set_css_tag(e.detail.font, 'rTXTFF')
	}

	const set_rooms_text_font_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'rTXTFS')
	}

	const set_rooms_price_font_color = (e) => {
		set_css_tag(e.detail.color, 'rPFC')
	}

	const set_rooms_price_font_family = (e) => {
		set_css_tag(e.detail.font, 'rPFF')
	}

	const set_rooms_price_font_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'rPFS')
	}

	const set_rooms_link_font_color = (e) => {
		set_css_tag(e.detail.color, 'rLFC')
	}

	const set_rooms_link_font_family = (e) => {
		set_css_tag(e.detail.font, 'rLFF')
	}

	const set_rooms_link_font_size = (e) => {
		const sizestr = e.detail.size
		const size = string_to_fontsize(sizestr)
		set_css_tag(size, 'rLFS')
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === true ? false : true
				showTool2 = false
				showTool3 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === true ? false : true
				showTool5 = false
				showTool6 = false
				showTool7 = false
				showTool8 = false

				break

			case 'generalTool3':
				generalTool3 = generalTool3 === true ? false : true
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true
				storeShowRooms.set(false)
				showTool1 = false
				showTool4 = false
				showTool9 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				storeShowRooms.set(false)
				showTool0 = false
				showTool4 = false
				showTool9 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool1 = false
				showTool3 = false
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool1 = false
				showTool2 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				storeShowRooms.set(false)
				showTool1 = false
				showTool0 = false
				showTool9 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				showTool8 = false
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool5 = false
				showTool7 = false
				showTool8 = false
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool5 = false
				showTool8 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				showTool5 = false
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				if (showTool9) storeShowRooms.set(true)
				if (!showTool9) storeShowRooms.set(false)
				showTool1 = false
				showTool4 = false
				showTool0 = false
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				break

			case 12:
				showTool12 = showTool12 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool10 = false
				showTool13 = false
				showTool14 = false
				break

			case 13:
				showTool13 = showTool13 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				showTool10 = false
				showTool14 = false
				break

			case 14:
				showTool14 = showTool14 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool10 = false
				break
		}
	}

	const change_order = (block, direction) => {
		storeShowRooms.set(false)
		const toChange = setTimeout(() => {
			re_order(block, direction)
			clearTimeout(toChange)
		}, 100)
	}

	const re_order = async (block, direction) => {
		let changeOrder = true
		blocks = get_blocks(config)
		blocks.forEach((bl) => {
			if (bl.blockName === block && bl.layoutOrder === 0 && direction === 'up') {
				changeOrder = false
			}

			if (bl.blockName === block && bl.layoutOrder === blocks.length - 1 && direction === 'down') {
				changeOrder = false
			}
		})
		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			storeData.set(reorder)
			shaderChangeOrder = false
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(0)}
				on:keydown={() => open_tool(0)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				LAYOUT POSITION
			</div>
			{#if showTool0}
				<div transition:slide={{ duration: 500 }}>
					
						<div class="icon_container">
							<div
								class="icon arrow_down"
								use:styles={{ icon, iconColor, iconHover }}
								on:click={() => change_order(blockID, 'down')}
								on:keydown={() => change_order(blockID, 'down')}
							/>
							<div
								class="icon arrow_up"
								use:styles={{ icon, iconColor, iconHover }}
								on:click={() => change_order(blockID, 'up')}
								on:keydown={() => change_order(blockID, 'up')}
							/>
						</div>
					
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				CONTAINER
			</div>

			{#if showTool1}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool1')}
						on:keydown={() => open_tool('generalTool1')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool1}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_bg_color}
								on:setopacity={set_bg_color}
								on:settransparent={set_bg_color}
								transparent="1"
								ID={idColor1}
								selectedColor={blockBackgroundColor}
								initialValue={blockBgOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector ID={idMarginTop} range="20" initialValue={blockMarginTop} on:sizechange={set_margin_top} />

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMarginBottom}
								range="20"
								initialValue={blockMarginBottom}
								on:sizechange={set_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idPadding} range="20" initialValue={blockPadding} on:sizechange={set_padding} />
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(2)}
						on:keydown={() => open_tool(2)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>

					{#if showTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon1"
									class="icon icon1"
									use:styles={{ icon, icon1Color, iconHover }}
									on:click={set_icon_1}
									on:keydown={set_icon_1}
								/>
								<div
									id="icon2"
									class="icon icon2"
									use:styles={{ icon, icon2Color, iconHover }}
									on:click={set_icon_2}
									on:keydown={set_icon_2}
								/>
								<div
									id="icon3"
									class="icon icon3"
									use:styles={{ icon, icon3Color, iconHover }}
									on:click={set_icon_3}
									on:keydown={set_icon_3}
								/>
								<div
									id="icon4"
									class="icon icon4"
									use:styles={{ icon, icon4Color, iconHover }}
									on:click={set_icon_4}
									on:keydown={set_icon_4}
								/>
								<div
									id="icon5"
									class="icon icon5"
									use:styles={{ icon, icon5Color, iconHover }}
									on:click={set_icon_5}
									on:keydown={set_icon_5}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_border_color}
										on:setopacity={set_border_color}
										ID={idColor2}
										selectedColor={selectedBorderColor}
										initialValue={blockBorderOpac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idBorderWidth}
										range="50"
										unit="px"
										initialValue={selectedBorderWidth}
										on:sizechange={set_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idBTradius}
										initialValue={borderTopRadius}
										unit="px"
										range="20"
										on:sizechange={set_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idBBradius}
										initialValue={borderBottomRadius}
										range="20"
										unit="px"
										on:sizechange={set_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(3)}
						on:keydown={() => open_tool(3)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_shadow_color}
								on:setopacity={set_shadow_color}
								ID={idColor3}
								selectedColor={blockBoxShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idShadowY}
								range="20"
								unit="px"
								initialValue={blockBoxShadowY}
								on:sizechange={set_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idShadowBlur}
								range="20"
								unit="px"
								initialValue={blockBoxShadowBlur}
								on:sizechange={set_blur}
							/>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(4)}
				on:keydown={() => open_tool(4)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				TITLE
			</div>

			{#if showTool4}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool2')}
						on:keydown={() => open_tool('generalTool2')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_title_bg_color}
								on:setopacity={set_title_bg_color}
								on:settransparent={set_title_bg_color}
								transparent="1"
								ID={idColor4}
								selectedColor={blockTitleBackgroundColor}
								initialValue={blockTitleBgOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Height</div>
							<SizeSelector
								ID={idTitleHeight}
								range="200"
								unit="px"
								initialValue={blockTitleHeight}
								on:sizechange={set_title_height}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idTitleMT}
								range="20"
								initialValue={blockTitleMarginTop}
								on:sizechange={set_title_margin_top}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idTitleMB}
								range="20"
								initialValue={blockTitleMarginBottom}
								on:sizechange={set_title_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector
								ID={idTitleP}
								range="20"
								initialValue={blockTitlePadding}
								on:sizechange={set_title_padding}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(5)}
						on:keydown={() => open_tool(5)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						box shadow
					</div>
					{#if showTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_shadow_color}
								on:setopacity={set_title_shadow_color}
								ID={idColor5}
								selectedColor={blockTitleShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTitleShadowY}
								range="20"
								unit="px"
								initialValue={blockTitleShadowOffsetY}
								on:sizechange={set_title_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTitleShadowBlur}
								range="20"
								unit="px"
								initialValue={blockTitleShadowBlur}
								on:sizechange={set_title_blur}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(6)}
						on:keydown={() => open_tool(6)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>

					{#if showTool6}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_font_color}
								on:setopacity={set_title_font_color}
								ID={idColor6}
								selectedColor={blockTitleFontColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_block_title_font_family}
								value={blockTitleFontFamily}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_block_title_font_size}
								value={blockTitleFontSize}
								ID={idSelect2}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fweight"
									class="icon iconWeight"
									use:styles={{ icon, iconWeight, iconHover }}
									on:click={set_block_title_font_weight}
									on:keydown={set_block_title_font_weight}
								/>
								<div
									id="fstyle"
									class="icon iconStyle"
									use:styles={{ icon, iconStyle, iconHover }}
									on:click={set_block_title_font_style}
									on:keydown={set_block_title_font_style}
								/>
								<div
									id="fdeco"
									class="icon iconDeco"
									use:styles={{ icon, iconDeco, iconHover }}
									on:click={set_block_title_font_underline}
									on:keydown={set_block_title_font_underline}
								/>
								<div
									id="fstroke"
									class="icon iconStroke"
									use:styles={{ icon, iconStroke, iconHover }}
									on:click={set_block_title_font_strikethrough}
									on:keydown={set_block_title_font_strikethrough}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(7)}
						on:keydown={() => open_tool(7)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font shadow
					</div>
					{#if showTool7}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_TXT_shadow_color}
								on:setopacity={set_title_TXT_shadow_color}
								ID={idColor7}
								selectedColor={blockTitleTXTShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idTTXTShadowX}
								range="20"
								unit="px"
								initialValue={blockTitleTXTShadowOffsetX}
								on:sizechange={set_title_TXT_offset_x}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTTXTShadowY}
								range="20"
								unit="px"
								initialValue={blockTitleTXTShadowOffsetY}
								on:sizechange={set_title_TXT_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTTXTShadowBlur}
								range="20"
								unit="px"
								initialValue={blockTitleTXTShadowBlur}
								on:sizechange={set_title_TXT_blur}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(8)}
						on:keydown={() => open_tool(8)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						alignment
					</div>
					{#if showTool8}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="cAlignL"
									class="icon txtContAlignL"
									use:styles={{ icon, iconTxtContAlignL, iconHover }}
									on:click={set_txt_container_align_left}
									on:keydown={set_txt_container_align_left}
								/>

								<div
									id="cAlignC"
									class="icon txtContAlignC"
									use:styles={{ icon, iconTxtContAlignC, iconHover }}
									on:click={set_txt_container_align_center}
									on:keydown={set_txt_container_align_center}
								/>

								<div
									id="cAlignR"
									class="icon txtContAlignR"
									use:styles={{ icon, iconTxtContAlignR, iconHover }}
									on:click={set_txt_container_align_right}
									on:keydown={set_txt_container_align_right}
								/>
							</div>
							<div class="icon_container">
								<div
									id="vAlignT"
									class="icon txtValignT"
									use:styles={{ icon, iconValignT, iconHover }}
									on:click={set_txt_container_valign_top}
									on:keydown={set_txt_container_valign_top}
								/>

								<div
									id="vAlignC"
									class="icon txtValignC"
									use:styles={{ icon, iconValignC, iconHover }}
									on:click={set_txt_container_valign_center}
									on:keydown={set_txt_container_valign_center}
								/>

								<div
									id="vAlignB"
									class="icon txtValignB"
									use:styles={{ icon, iconValignB, iconHover }}
									on:click={set_txt_container_valign_bottom}
									on:keydown={set_txt_container_valign_bottom}
								/>
							</div>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(9)}
				on:keydown={() => open_tool(9)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				ROOMS
			</div>
			{#if showTool9}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool3')}
						on:keydown={() => open_tool('generalTool3')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_rooms_bg}
								on:setopacity={set_rooms_bg}
								ID={idColor8}
								selectedColor={roomsBG}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector ID={idRoomsMT} range="20" unit="%" initialValue={roomsMT} on:sizechange={set_rooms_mt} />

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector ID={idRoomsMB} range="20" unit="%" initialValue={roomsMB} on:sizechange={set_rooms_mb} />

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idRoomsP} range="20" unit="%" initialValue={roomsP} on:sizechange={set_rooms_p} />

							<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
							<ColorSelector
								on:setcolor={set_rooms_border_c}
								on:setopacity={set_rooms_border_c}
								ID={idColor9}
								selectedColor={roomsBG}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Border Width</div>
							<SizeSelector
								ID={idRoomsBW}
								range="20"
								unit="px"
								initialValue={roomsBW}
								on:sizechange={set_rooms_border_w}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Radius Top</div>
							<SizeSelector
								ID={idRoomsBRT}
								range="50"
								unit="px"
								initialValue={roomsBRT}
								on:sizechange={set_rooms_brt}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Radius Bottom</div>
							<SizeSelector
								ID={idRoomsBRB}
								range="50"
								unit="px"
								initialValue={roomsBRB}
								on:sizechange={set_rooms_brb}
							/>
						</div>

						<div class="sub_title" use:styles={{ fsXS }}>Shadow Color</div>
						<ColorSelector
							on:setcolor={set_rooms_shadow_c}
							on:setopacity={set_rooms_shadow_c}
							ID={idColor10}
							selectedColor={roomsSC}
						/>
						<div class="sub_title" use:styles={{ fsXS }}>OffsetX</div>
						<SizeSelector
							ID={idRoomsSX}
							range="10"
							unit="px"
							initialValue={roomsSX}
							on:sizechange={set_rooms_shadow_x}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>OffsetY</div>
						<SizeSelector
							ID={idRoomsSY}
							range="10"
							unit="px"
							initialValue={roomsSY}
							on:sizechange={set_rooms_shadow_y}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
						<SizeSelector
							ID={idRoomsSB}
							range="10"
							unit="px"
							initialValue={roomsSB}
							on:sizechange={set_rooms_shadow_b}
						/>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(10)}
						on:keydown={() => open_tool(10)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						title
					</div>

					{#if showTool10}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_rooms_title_font_color}
								on:setopacity={set_rooms_title_font_color}
								ID={idColor11}
								selectedColor={roomsTFC}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_rooms_title_font_family}
								value={roomsTFF}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSizeSmall}
								on:select={set_rooms_title_font_size}
								value={roomsTFS}
								ID={idSelect2}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(11)}
						on:keydown={() => open_tool(11)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						image
					</div>
					{#if showTool11}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Size</div>
							<SizeSelector ID={idRoomsIMGW} range="100" initialValue={roomsIMGW} on:sizechange={set_rooms_imgw} />
						</div>

						<div class="sub_title" use:styles={{ fsXS }}>Shadow Color</div>
						<ColorSelector
							on:setcolor={set_rooms_img_sc}
							on:setopacity={set_rooms_img_sc}
							ID={idColor12}
							selectedColor={roomsIMGC}
						/>
						<div class="sub_title" use:styles={{ fsXS }}>OffsetX</div>
						<SizeSelector
							ID={idRoomsIMGSX}
							range="10"
							unit="px"
							initialValue={roomsIMGX}
							on:sizechange={set_rooms_img_sx}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>OffsetY</div>
						<SizeSelector
							ID={idRoomsIMGSY}
							range="10"
							unit="px"
							initialValue={roomsIMGY}
							on:sizechange={set_rooms_img_sy}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
						<SizeSelector
							ID={idRoomsIMGSB}
							range="10"
							unit="px"
							initialValue={roomsIMGB}
							on:sizechange={set_rooms_img_sb}
						/>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(12)}
						on:keydown={() => open_tool(12)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						text
					</div>
					{#if showTool12}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_rooms_text_font_color}
								on:setopacity={set_rooms_text_font_color}
								ID={idColor13}
								selectedColor={roomsDescShortFC}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_rooms_text_font_family}
								value={roomsDescShortFF}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSizeSmall}
								on:select={set_rooms_text_font_size}
								value={roomsDescShortFS}
								ID={idSelect2}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(13)}
						on:keydown={() => open_tool(13)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						price
					</div>
					{#if showTool13}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_rooms_price_font_color}
								on:setopacity={set_rooms_price_font_color}
								ID={idColor14}
								selectedColor={roomsPriceFC}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_rooms_price_font_family}
								value={roomsPriceFF}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSizeSmall}
								on:select={set_rooms_price_font_size}
								value={roomsPriceFS}
								ID={idSelect2}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(14)}
						on:keydown={() => open_tool(14)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						link
					</div>

					{#if showTool14}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_rooms_link_font_color}
								on:setopacity={set_rooms_link_font_color}
								ID={idColor15}
								selectedColor={roomsLinkFC}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_rooms_link_font_family}
								value={roomsLinkFF}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSizeSmall}
								on:select={set_rooms_link_font_size}
								value={roomsLinkFS}
								ID={idSelect2}
							/>
						</div>
					{/if}
				</div>
			{/if}
		</section>
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.iconWeight {
		background-color: var(--iconWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconStyle {
		background-color: var(--iconStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconDeco {
		background-color: var(--iconDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconStroke {
		background-color: var(--iconStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.txtContAlignL {
		background-color: var(--iconTxtContAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtContAlignC {
		background-color: var(--iconTxtContAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtContAlignR {
		background-color: var(--iconTxtContAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtValignT {
		background-color: var(--iconValignT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	.txtValignC {
		background-color: var(--iconValignC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	.txtValignB {
		background-color: var(--iconValignB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
